import React, { useEffect, useState } from "react";
import JobChecklistForm from "../../../components/Jobs/JobsChecklist/JobChecklistForm";
import { connect } from "react-redux";
import {
  getJobChecklistSingleDataAction,
  resetError,
  resetJobChecklistData,
  resetJobChecklistSingleData,
  resetMessage,
  resetStatusCode,
  resetSuccess,
  updateJobChecklistDataAction,
} from "../../../redux/jobs";
import { resetSession } from "../../../redux/auth";
import { RootState } from "../../../redux/rootReducers";
import { ErrorSuccessModal, Loader } from "../../../components/commons";
import {  ChecklistItemType, GetJobCheckListPayloadType, ProceduresType, ProcedureType, UpdateJobCheckListPayloadType } from "../../../commonTypes/jobsType";
import toast, { Toaster } from "react-hot-toast";
import GuideLinesModal from "../../../components/Jobs/JobsChecklist/GuideLinesModal";

type AppProps = {
  token: string | null;
  success: number | null;
  fetching: boolean;
  error: string | null | undefined;
  message: string | null | undefined;
  statusCode: number | null;
  history?: any;
  totalJobsCount: number;
  jobChecklistSingleData: ChecklistItemType | null;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetJobsList: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchEditJobChecklist: (data: UpdateJobCheckListPayloadType) => void;
  dispatchGetSingleJobCheckListData: (data: GetJobCheckListPayloadType) => void;
  dispatchResetJobChecklist: () => void;
  dispatchResetJobChecklistSingleData: () => void;
};

const EditJobChecklist = ({
  token,
  success,
  fetching,
  error,
  statusCode,
  history,
  totalJobsCount,
  message,
  jobChecklistSingleData,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetSuccess,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchEditJobChecklist,
  dispatchGetSingleJobCheckListData,
  dispatchResetJobChecklist,
  dispatchResetJobChecklistSingleData,
}: AppProps) => {
  const searchTerm = history?.location?.state?.searchTerm;

  const [data, setData] = useState<ProceduresType>([]);
  const [title, setTitle] = useState<string>("");
  const job_type_id =
    history &&
    history?.location &&
    history?.location?.state &&
    history?.location?.state?.job_id;
  const jobChecklistId = history?.location?.state?.id;
  const [fileData, setFileData] = useState("");
  const [guidelineModal,setGuidelineModal] = useState<boolean>(false);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetJobChecklistSingleData();
    if (token) {
      let finalData = {
        token,
        jobTypeId: jobChecklistId,
      };
      dispatchGetSingleJobCheckListData(finalData);
    }
  }, []);

  useEffect(() => {
    if (jobChecklistSingleData?._id) {
      setFileData(jobChecklistSingleData?.guideline)
      setTitle(jobChecklistSingleData?.title);
      setData([...jobChecklistSingleData?.procedures]);
    }
  }, [jobChecklistSingleData]);

  const flatten: any = (data: any) => {
    const result = [];
    for (const item of data) {
      result.push(item);
      if (item.subHeading) {
        result.push(...flatten(item.subHeading));
      }
      if (item.firstLevel) {
        result.push(...flatten(item.firstLevel));
      }
      if (item.secondLevel) {
        result.push(...flatten(item.secondLevel));
      }
    }
    return result;
  };

  const handleEditJobChecklist = () => {
    let flattenData = flatten(data);
    let isValidate = flattenData?.find(
      (item: ProcedureType) => !item?.value?.trim()  && !item?.is_deleted
    );
    if (!isValidate) {
      if (token) {
        let finalData = {
          token,
          data: {
            title,
            guideline:fileData,
            procedures: data,
            job_type: job_type_id,
            job_checklist_id: jobChecklistId,
          },
        };
        dispatchEditJobChecklist(finalData);
      }
    } else {
      toast.error("Please fill all the fields or delete it", {
        duration: 2000,
      });
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
              dispatchResetMessage();
              dispatchResetStatusCode();
              dispatchResetSuccess();
            }}
          />
        );
      }
    }

    if (success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`Checklist Updated Successfully!`}
          buttonText="OK"
          onPress={() => {
            dispatchResetError();
            dispatchResetMessage();
            dispatchResetStatusCode();
            dispatchResetSuccess();
            dispatchResetJobChecklist();
            history?.push({
              pathname: `/jobs/jobs-type/checklist`,
              state: { job_id: job_type_id ,searchTerm : searchTerm?.trim()},
            });
          }}
          statusCode={statusCode}
        />
      );
    }
  };

  return (
    <div>
      <div className="pl-3 job-checklist">
        <JobChecklistForm
          history={history}
          data={data}
          title={title}
          fileData={fileData}
          setTitle={setTitle}
          setData={setData}
          setModal={setGuidelineModal}
          handleSubmit={handleEditJobChecklist}
          type="Edit"
        />
      </div>
      {guidelineModal ?  <GuideLinesModal modal={guidelineModal} setModal={setGuidelineModal} fileData={fileData} setFileData={setFileData}/> : null}
      <Toaster />
      {handleErrorModal()}
      {fetching && <Loader />}
    </div>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  jobsList: state.jobs.jobsList,
  totalJobsCount: state.jobs.totalJobsCount,
  fetching: state.jobs.fetching,
  success: state.jobs.success,
  statusCode: state.jobs.statusCode,
  error: state.jobs.error,
  message: state.jobs.message,
  jobChecklistSingleData: state.jobs.jobChecklistSingleData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetSuccess()),
  dispatchResetMessage: () => dispatch(resetMessage()),
  dispatchResetError: () => dispatch(resetError()),
  dispatchResetStatusCode: () => dispatch(resetStatusCode()),
  dispatchEditJobChecklist: (data: UpdateJobCheckListPayloadType) =>
    dispatch(updateJobChecklistDataAction(data)),
  dispatchGetSingleJobCheckListData: (data: GetJobCheckListPayloadType) =>
    dispatch(getJobChecklistSingleDataAction(data)),
  dispatchResetJobChecklist: () => dispatch(resetJobChecklistData()),
  dispatchResetJobChecklistSingleData: () =>
    dispatch(resetJobChecklistSingleData()),
});

export default connect(mapStateTopProps, mapDispatchToProps)(EditJobChecklist);
